export const AUTH_ROUTES = {
	LOGIN: "/login",
} as const;
